module.exports = __webpack_public_path__ + "img/IMG_8157_L_Black_MockedUp.124719a7.jpg";